import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  getMarketplaceOperatorAgreementsPath,
  getMarketplaceOperatorAdminBillingPath,
  getMarketplaceOperatorHubPath,
  getMarketplaceOperatorLedgerPath,
  getMarketplaceOperatorPayoutsPath,
  getMarketplaceOperatorSettingsPath,
  getMarketplaceOperatorWorkspacesPath,
} from "../../../utils/marketplaceOperatorRoutes";

const tabs = [
  { to: getMarketplaceOperatorHubPath(), label: "Dashboard" },
  { to: getMarketplaceOperatorWorkspacesPath(), label: "Workspaces" },
  { to: getMarketplaceOperatorAgreementsPath(), label: "Rental Agreements" },
  { to: getMarketplaceOperatorPayoutsPath(), label: "Payouts" },
  { to: getMarketplaceOperatorLedgerPath(), label: "Ledger" },
  { to: getMarketplaceOperatorAdminBillingPath(), label: "Payments" },
  { to: getMarketplaceOperatorSettingsPath(), label: "Settings" },
];

export const rentalsHeroSecondaryActionClass =
  "rounded-full border border-[#2f3566]/20 bg-white px-5 py-2.5 text-sm font-semibold text-[#2f3566] shadow-sm transition hover:bg-[#2f3566]/5";

export default function RentalsShell({
  eyebrow = "MyBoothShare Operator",
  title,
  description,
  actions = null,
  children,
}) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV !== "test" && typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0 });
    }
  }, [pathname]);

  return (
    <div className="myboothshare-shell manageSectionShell min-h-screen">
      <div className="manageSectionWide manage-section-wide space-y-6">
        <section className="myboothshare-hero-card rounded-[28px] border border-white/70 bg-white/75 shadow-[0_20px_70px_rgba(47,53,102,0.12)] backdrop-blur">
          <div className="border-b border-slate-200/70 px-6 py-6 text-slate-900">
            <p className="inline-flex rounded-full border border-rose-200 bg-rose-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-rose-600">
              {eyebrow}
            </p>
            <div className="mt-3 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
              <div className="space-y-2">
                <h1 className="text-2xl font-semibold leading-tight text-slate-950 md:text-3xl">
                  {title}
                </h1>
                <p className="max-w-3xl text-sm leading-6 text-slate-600 md:text-base">
                  {description}
                </p>
              </div>
              {actions ? <div className="flex flex-wrap gap-3">{actions}</div> : null}
            </div>
          </div>
          <div className="flex flex-wrap gap-2 px-6 py-4">
            {tabs.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                className={({ isActive }) =>
                  `rounded-full px-4 py-2 text-sm font-semibold transition ${
                    isActive
                      ? "bg-rose-500 text-white shadow-sm"
                      : "border border-[#2f3566]/15 bg-white text-[#2f3566] hover:bg-[#2f3566]/5"
                  }`
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </div>
        </section>
        {children}
      </div>
    </div>
  );
}
